import ListQueries from "../../components/cohort-queries/ListQueries";
import styles from "./StudyContent.module.scss";
import buttonStyles from "../../components/common/styled/Buttons.module.scss";
import { useState } from "react";
import { Drawer, Col, Row, Button, Divider } from "antd";
import React from "react";

const StudySection: React.FC = ({children}) => {
    return <>
        <div className={styles['study-section']}>{children}</div>
        <Divider className={styles['study-section-divider']}/>
    </>
}

export const StudyLayout: React.FC<{ title: string, floatSidebar: boolean }> = ({ title, floatSidebar, children }) => {

    const [queriesVisible, setQueriesVisible] = useState<boolean>(false)

    const closeDrawer = () => {
        setQueriesVisible(!queriesVisible)
    }

    const listQueries = () => {
        if (floatSidebar) {
            return <Drawer open={queriesVisible} placement="right" onClose={closeDrawer} width={736}>
                <ListQueries />
            </Drawer>
        } else {
            return <Col span={8}>
                <ListQueries />
            </Col>
        }
    }

    return <>
        <Row>
            <StudySection>
                <div className={styles['study-section-title']}>
                    <div>{title}</div>
                    <div>
                        <Button
                            hidden={!floatSidebar}
                            type="primary"
                            className={`${buttonStyles["primary"]}`}
                            style={{ margin: "0 5px 0 5px" }}
                            onClick={() => { closeDrawer() }}
                        >
                            My Cohorts
                        </Button>
                    </div>
                </div>
            </StudySection>
        </Row>
        <Row>
            <Col span={floatSidebar ? 24 : 16}>
                {children}
            </Col>
            {listQueries()}
        </Row>
    </>
}
